module.exports = __webpack_public_path__ + "static/media/Fletchling_gaussian2.67d3750a.png";